import Axios from 'axios';

import handleError from './handleError';
import handleSuccess from './handleSuccess';

export const api = Axios.create({
  baseURL: '/api',
});

api.defaults.headers.post['Content-Type'] = 'application/json';

api.interceptors.response.use(
  (response) => handleSuccess(response),
  (error) => handleError(error),
);
